import request from '@/utils/request'
export function exportExcel(data) {
  return request({
    url:'/order/exportExcle',
    method:'post',
    data:data
  })
}

export function getPendingOrder(){
  return request({
    url:'/order/getPendingOrder',
    method:'get'
  })
}

export function fetchList(params) {
  return request({
    url:'/order/list',
    method:'get',
    params:params
  })
}

export function createOrderStatic(data){
  return request({
    url:'order/createOrderStatic',
    method:'post',
    data:data
  })
}

export function fetchAllList(params) {
  return request({
    url:'/order/getAll',
    method:'get',
    params:params
  })
}

export function finishOrder(params) {
  return request({
    url:'/order/update/finish',
    method:'post',
    params:params
  })
}

export function closeOrder(params) {
  return request({
    url:'/order/update/close',
    method:'post',
    params:params
  })
}

export function signOrderMessage(params) {
  return request({
    url:'/order/update/signOrderMessage',
    method:'post',
    params:params
  })
}

export function deleteOrder(params) {
  return request({
    url:'/order/delete',
    method:'post',
    params:params
  })
}

export function signOrder(data) {
  return request({
    url:'/order/update/sign',
    method:'post',
    data:data
  });
}

export function deliveryOrder(data) {
  return request({
    url:'/order/update/delivery',
    method:'post',
    data:data
  });
}

export function receiveOrder(params) {
  return request({
    url:'/order/update/receive',
    method:'post',
    params:params
  })
}

export function auditOrder(params) {
  return request({
    url:'/order/update/audit',
    method:'post',
    params:params
  })
}

export function getOrderDetail(id) {
  return request({
    url:'/order/'+id,
    method:'get'
  });
}

export function updateReceiverInfo(data) {
  return request({
    url:'/order/update/receiverInfo',
    method:'post',
    data:data
  });
}

export function updateMoneyInfo(data) {
  return request({
    url:'/order/update/moneyInfo',
    method:'post',
    data:data
  });
}

export function updateOrderNote(params) {
  return request({
    url:'/order/update/note',
    method:'post',
    params:params
  })
}

export function fetchHomeStaticF() {
  return request({
    url: '/order/homeStaticF',
    method: 'get'
  })
}

export function fetchHomeStaticT() {
  return request({
    url: '/order/homeStaticT',
    method: 'get'
  })
}

export function fetchHomeStaticS() {
  return request({
    url: '/order/homeStaticS',
    method: 'get'
  })
}

export function fetchHomeStaticD() {
  return request({
    url: '/order/homeStaticD',
    method: 'get'
  })
}

export function fetchHomeStaticF1() {
  return request({
    url: '/order/homeStaticF1',
    method: 'get'
  })
}

export function fetchHomeStaticT1() {
  return request({
    url: '/order/homeStaticT1',
    method: 'get'
  })
}

export function fetchHomeStaticS1() {
  return request({
    url: '/order/homeStaticS1',
    method: 'get'
  })
}

export function fetchHomeStaticD1() {
  return request({
    url: '/order/homeStaticD1',
    method: 'get'
  })
}

export function fetchHomeOrderStatic(params) {
  return request({
    url: '/order/homeOrderStatic',
    method: 'post',
    params: params
  })
}

export function exportList(params) {
  return request({
    url:'/order/list',
    method:'get',
    params:params
  })
}


export function createDeliveryPdf(params){
  return request({
    url:'order/createDeliveryPdf',
    method:'post',
    data:params
  })
}

export function createOrderBill(data){
  return request({
    url:'order/createOrderBill',
    method:'post',
    data:data
  })
}


export function createProductStatic(data){
  return request({
    url:'order/createProductStatic',
    method:'post',
    data:data
  })
}

export function createProductNum(data){
  return request({
    url:'order/createProductNum',
    method:'post',
    data:data
  })
}

export function createProductAmount(data){
  return request({
    url:'order/createProductAmount',
    method:'post',
    data:data
  })
}


export function getBillProjects(params) {
  return request({
    url:'/order/getBillProjects',
    method:'post',
    params:params
  })
}

export function getBillmembers(params) {
  return request({
    url:'/order/getBillMembers',
    method:'post',
    params:params
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js